import { FormikTouched } from 'formik';
import {
  Design,
  FormPageInputItem,
  FormPageProperty,
  ToKeyValueTuple,
} from 'shared';

export type FormFieldProps<T extends FormPageProperty = FormPageProperty> = {
  property: T;
  disabled: boolean;
  design: Design;
  submitted: boolean;
  reEnter?: boolean;
};

export type FormFieldInputProps<
  P extends FormPageProperty = FormPageProperty,
  I extends FormPageInputItem = FormPageInputItem
> = {
  property: P;
  disabled: boolean;
  design: Design;
  onChange: (...updateKeyValue: ToKeyValueTuple<I>) => void;
  onBlur: (...updateKeyValue: ToKeyValueTuple<I>) => void;
  value: I;
  className?: string;
  errorMessages?: string[];
  touched: FormikTouched<I> | undefined;
  submitted: boolean;
  reEnter?: boolean;
};

export type FormFieldInputItemProps<
  P extends FormPageProperty = FormPageProperty,
  I extends FormPageInputItem = FormPageInputItem
> = Omit<FormFieldInputProps<P, I>, 'touched' | 'submitted' | 'value'> & {
  displayError: boolean;
};

export const hasErrorMessage = (
  errorMessages: FormFieldInputProps['errorMessages']
): boolean => errorMessages != null && errorMessages.length > 0;
